import { useState, useEffect } from 'react';

function useScreenSize() {
  const [screenSize, setScreenSize] = useState({
    isMobile: false,
    isTablet: false,
    isDesktop: false,
  });

  useEffect(() => {
    function handleResize() {
      const screenWidth = window.innerWidth;
      setScreenSize({
        isMobile: screenWidth < 640,
        isTablet: screenWidth >= 640 && screenWidth < 1024,
        isDesktop: screenWidth >= 1024,
      });
    }

    // Initial check on mount
    handleResize();

    // Listen for window resize events
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); // Empty dependency array to run effect only once on mount

  return screenSize;
};

export default useScreenSize;